/* eslint-disable no-undef */
module.exports = function () {
    // Flipp Hosted Circular
    $(document).ready( () => {
        var flippContainer = document.querySelector('#flipp-container');
        var storefront = new Flipp.Storefront({
            accessToken: '1ddfda9d56236c47ae8fbcd9f508ced1',
            merchantId: '246',
            locale: $('.js-locale').data('locale').replace('_', '-'),
            merchantNameIdentifier: 'toysruscanada'
        });
        storefront.renderStorefront(flippContainer);
    });
};
